export default function timeRangeForNew(moment: any) {
  return moment().subtract(7, "d").format("YYYY-MM-DD");
}
